import Vue from 'vue';
import Router from 'vue-router';
import ReportingPage from '../../templates/ReportingPage.vue';
import CertificatePage from '../../templates/CertificatePage.vue';
import StatePage from '../../templates/StatePage.vue';
import TeamPage from '../../templates/TeamPage.vue';
import DepotGraph from '../../templates/DepotGraph';
import BarChart from '../../templates/BarChart';
import LoginPage from '../../templates/LoginPage.vue';
import LogoutPage from '../../templates/LogoutPage.vue';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: '/frontend',
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage,
    },
    {
      path: '/',
      redirect: '/state'
    },
    {
      path: '/state',
      name: 'Status',
      component: StatePage,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/reporting',
      name: 'Auswertung',
      component: ReportingPage,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/reporting/:periodIndex/:id',
      component: TeamPage,
      props: true,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/depot-graph',
      name: 'Kursverläufe',
      component: DepotGraph,
      meta: {
        requiresAuth: true,
        seminar: ['trading_heroes']
      }
    },
    {
      path: '/graphs',
      name: 'Graph-Auswertungen',
      component: BarChart,
      meta: {
        requiresAuth: true,
        seminar: ['founding_heroes']
      }
    },
    {
      path: '/certificate',
      name: 'Zertifikate',
      component: CertificatePage,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/logout',
      name: 'Ausloggen',
      component: LogoutPage,
      meta: {
        requiresAuth: true
      }
    }
  ]
});


router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (localStorage.getItem('access') === null || localStorage.getItem('access') === '') {
            next({
                path: '/login',
                params: { nextUrl: to.fullPath }
            })
        } else {
            next()
        }
    } else {
        next()
    }
});

export default router
